import { PricingType } from '~/constants';
import { useProjectContext } from '~/hooks';

export default function EpcCostsText() {
  const { project } = useProjectContext();
  const { pricingType } = project;

  return (
    <>
      {pricingType === PricingType.ACQUISITION ?
        <>
          <h3 style={{ fontSize: '14px' }}>EPC cost + Dev fee</h3>
          <p style={{ margin: ' var(--x-small) 0 var(--medium) 0' }}>
            Please note that investors will be bidding a combined EPC cost plus development fee; you should not include EPC costs anywhere on this page.
          </p>
        </>
        : null}
      {pricingType === PricingType.DEV_FEE ?
        <>
          <h3 style={{ fontSize: '14px' }}>Development Fee</h3>
          <p style={{ margin: ' var(--x-small) 0 var(--medium) 0' }}>
            Please note that investors will be bidding a development fee; you should not include development fee anywhere on this page. It is optional, but recommended, to include an EPC price.
          </p>
        </>
        : null}
    </>
  );

}